import StackAPI from '../../../lib/StackAPI'

const ENDPOINT = '/partners/vendor/batches_importer'

export const API_ERROR = 'An error occurred while uploading the file'
export const INVALID_ERROR = 'The file format or its content is invalid'

interface Params {
  file: File
  disableEmail: boolean
}

interface Result {
  workerId?: string
  error?: string
}

const validate = (file: File) => {
  if (!file) return false
  if (file.type !== 'text/csv') return false
  return true
}

const buildFormData = ({ file, disableEmail }: Params) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('data', JSON.stringify({ disableEmail }))
  return formData
}

const batchUploadCsv = async ({
  file,
  disableEmail
}: Params): Promise<Result> => {
  if (!validate(file)) return { error: INVALID_ERROR }

  const { post } = StackAPI()
  const formData = buildFormData({ file, disableEmail })
  const response = await post({
    path: ENDPOINT,
    params: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  if (response.status !== 200 || !response.data.worker_id)
    return { error: API_ERROR }

  return { workerId: response.data.worker_id }
}

export default batchUploadCsv
